import React from 'react';
import ProjectsCarousel from '../ProjectsCarousel/ProjectsCarousel';

const Projects = () => {
  return (
    <div>
      <ProjectsCarousel />
    </div>
  );
};

export default Projects;